import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { blockOnlineSale } from "../actions/matrixs";
import { requestProUpgrade, resetProUpgrade } from "../actions/license";

import RemoteActionCustomerSingleAddForm from "../forms/RemoteActionCustomerSingleAddForm";
import RemoteActionFaultAddForm from "../forms/RemoteActionFaultAddForm";
import RemoteActionFaultRepairForm from "../forms/RemoteActionFaultRepairForm";
import RemoteActionBaqueiraRentDaysForm from "../forms/RemoteActionBaqueiraRentDaysForm";
import RemoteActionBaqueiraBlockLockerForm from "../forms/RemoteActionBaqueiraBlockLockerForm";
import RemoteActionBaqueiraClickAndCollectForm from "../forms/RemoteActionBaqueiraClickAndCollectForm";
import RemoteActionBaqueiraWhitelistForm from "../forms/RemoteActionBaqueiraWhitelistForm";
import RemoteActionBaqueiraSeasonForm from "../forms/RemoteActionBaqueiraSeasonForm";
import "../styles/LockerModal.css";

class MatrixConstructor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      matrixModalOpen: false,
      matrixMatricula: "",
      currentView: "main",
      matrixSN: "",
      lockerType: "",
      blockType: null,
      blockedLockers: [],
      showButton: false, // Track button visibility
      buttonPosition: { x: 0, y: 0 }, // Track button position
      proModalOpen: false,
    };

    this.openMatrixDialog = this.openMatrixDialog.bind(this);
    this.closeMatrixDialog = this.closeMatrixDialog.bind(this);
    this.changeView = this.changeView.bind(this);
    this.updateBlockType = this.updateBlockType.bind(this);
    this.handleBlockedLocker = this.handleBlockedLocker.bind(this);
    this.handleRightClick = this.handleRightClick.bind(this);
    this.hideButton = this.hideButton.bind(this);
  }

  componentDidMount() {
    // Add a listener to handle page unload
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  }

  componentWillUnmount() {
    if (this.state.matrixSN !== "") {
      // Ensure blockType is set to false when the component unmounts
      //REVISAR this.props.blockOnlineSale(this.props.machine._id, false, this.state.matrixSN, this.state.matrixMatricula);
      // Remove the event listener
      window.removeEventListener("beforeunload", this.handleBeforeUnload);
    }
  }

  handleBeforeUnload = (event) => {
    if (this.state.matrixSN !== "") {
      // Set blockType to false on page unload
      //REVISAR this.props.blockOnlineSale(this.props.machine._id, false, this.state.matrixSN, this.state.matrixMatricula);

      // Optionally prevent the default behavior
      event.preventDefault();
      event.returnValue = "";
    }
  };

  openMatrixDialog(matricula, sn, type, block, e) {
    // GROUP customers are view-only on the matrix: they can see the locker
    // grid but cannot open the operate modal.
    if (this.props.role === "CUSTOMER" && this.props.type === "GROUP") {
      return;
    }
    this.setState(
      {
        matrixModalOpen: true,
        matrixMatricula: matricula,
        currentView: "main",
        matrixSN: sn,
        lockerType: type,
        blockType: block,
      },
      () => {
        // Call blockOnlineSale with blockType = true when the modal opens
        //REVISAR this.props.blockOnlineSale(this.props.machine._id, true, this.state.matrixSN, this.state.matrixMatricula);
      },
    );
  }

  closeMatrixDialog() {
    this.setState({ matrixModalOpen: false }, () => {
      // Call blockOnlineSale with blockType = false when the modal closes
      //REVISAR
      /*this.props.blockOnlineSale(this.props.machine._id, false, this.state.matrixSN, this.state.matrixMatricula)
        .then((response) => {
          this.setState({
            matrixMatricula: '',
            matrixSN: ''
          });
        })
        .catch((error) => {
          console.error('Error blocking locker:', error);
        });
        */
    });
  }

  changeView(view) {
    this.setState({ currentView: view });
  }

  updateBlockType(newBlockType) {
    this.setState({ blockType: newBlockType });
  }

  getErrorCode(error) {
    switch (error) {
      case "0x00":
        return "OK";
      case "0xFF":
        return "INITIALIZED";
      case "0x01":
        return "CONNECTED";
      case "0x02":
        return "ESP32 PROCESS SUCC";
      case "0x03":
        return "USER PIN ASSIGNED";
      case "0x04":
        return "CONN FAULT";
      case "0x05":
        return "SCAN TIMEOUT";
      case "0x06":
        return "GEN ERROR 1";
      case "0x07":
        return "ESP32 PROCESS UNSUCC";
      case "0x08":
        return "GEN ERROR 2";
      case "0x09":
        return "GEN ERROR 3";
      case "0x0A":
        return "GEN ERROR 4";
      case "0x0B":
        return "GEN ERROR 5";
      case "0x0C":
        return "USER PIN UNASSIGNED";
      default:
        return error;
    }
  }

  // Shared shell for every view reached from the main one: the form inside a
  // single lm-card. changeView("main") is the only way back.
  renderSubView(key, title, icon, content) {
    return (
      <CSSTransition key={key} timeout={300} classNames="fade">
        <div className="lm-body view-container slide-in">
          <div className="lm-subview">
            <div className="lm-card">
              <div className="lm-card-header">
                <i className={`fas fa-${icon}`}></i> {title}
              </div>
              <div className="lm-card-body">{content}</div>
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  }

  infoMatrix() {
    const { currentView, blockType } = this.state;
    const { role, category, refreshMatrix, articles, type } = this.props;

    let checkMatricula = "";
    let checkBLEName = "";
    let checkHobbit = false;
    let checkRfidUid = "";
    let checkMasterUid = "";
    let checkPin = "";
    let checkPhone = "";
    let checkName = "";
    let checkEmail = "";
    let checkModule = "";
    let checkPass = "";
    let checkAdmin = "";
    let checkType = "";
    let checkPosition = "";
    let checkStatus = "";
    let checkWide = "";
    let checkMode = "";
    let checkConfigured = false;
    let checkLastNightscan = "";
    let checkGender = "";
    let checkFaultCode = "";
    let checkErrorCode = "";
    let kerongVersion = "";
    let whitelistID = "";

    {
      this.props.matrixs.map((matrix) => {
        {
          matrix.Serial === this.props.machine.Serial &&
            matrix.Locker.map((lock, index) => {
              if (index + 1 == this.state.matrixMatricula) {
                checkMatricula = lock.Matricula || checkMatricula;
                checkType = lock.Type || checkType;
                checkBLEName = lock.BLEName || checkBLEName;
                checkRfidUid = lock.RfidUid || checkRfidUid;
                checkMasterUid = lock.MasterUid || checkMasterUid;
                checkPin = lock.Pin || checkPin;
                checkPhone = lock.Phone || checkPhone;
                checkEmail = lock.Email || checkEmail;
                checkName = lock.Name || checkName;
                checkModule = lock.ModuleSN || checkModule;
                checkPass = lock.Pass || checkPass;
                checkAdmin = lock.PasswordCash || checkAdmin;
                checkPosition = lock.Position || checkPosition;
                checkStatus = lock.Status || checkStatus;
                checkWide = lock.wide || checkWide;
                checkMode = lock.Mode || checkMode;
                checkConfigured = lock.Configured || checkConfigured;
                checkLastNightscan =
                  lock.LastNightScanCompleted || checkLastNightscan;
                checkGender = lock.Gender || checkGender;
                checkFaultCode = lock.FaultCode || checkFaultCode;
                checkErrorCode = lock.ErrorBle || checkErrorCode;
                kerongVersion = lock.KerongVersion || kerongVersion;
                whitelistID =
                  articles?.Whitelist?.find(
                    (item) => item._id === lock.BlockType,
                  )?.name || whitelistID;
              }
            });
        }
      });
    }

    const year = parseInt(checkLastNightscan.slice(0, 4));
    const month = parseInt(checkLastNightscan.slice(4, 6)) - 1; // month is zero-indexed
    const day = parseInt(checkLastNightscan.slice(6, 8));
    const hour = parseInt(checkLastNightscan.slice(8, 10));
    const minute = parseInt(checkLastNightscan.slice(10, 12));
    const second = parseInt(checkLastNightscan.slice(12, 14));

    const nightscanDate = new Date(year, month, day, hour, minute, second);

    nightscanDate.setHours(nightscanDate.getHours());
    const formattedDate = `${nightscanDate.getDate()}/${nightscanDate.getMonth() + 1}/${nightscanDate.getFullYear()}`;
    const formattedTime = `${nightscanDate.getHours().toString().padStart(2, "0")}:${nightscanDate.getMinutes().toString().padStart(2, "0")}`;

    if (currentView === "main") {
      const showBaqueira =
        role === "ADMIN" || (role === "CUSTOMER" && category === "BAQUEIRA");

      // Maquinas anteriores al campo no lo traen y se comportan como PIN, asi que
      // cualquier valor que no sea RFID cuenta como PIN (mismo criterio que
      // utils/machines.js getQuickAccessMode).
      const rfidMode = this.props.machine?.QuickAccessMode === "RFID";

      return (
        <CSSTransition key="main" timeout={300} classNames="fade">
          <div className="lm-body">
            <div className="lm-cols">

              {/* Column 1: Pines + Cliente + RFID */}
              <div className="lm-col">
                <div className="lm-card lm-card-dark">
                  <div className="lm-card-header lm-card-header-dark">
                    <i className="fas fa-key"></i> Pines
                  </div>
                  <div className={`lm-card-body${rfidMode ? " lm-locked" : ""}`}>
                    {rfidMode && (
                      <div className="lm-lock-overlay">
                        <i className="fas fa-lock"></i>
                        <span>Solo disponible en modo PIN</span>
                      </div>
                    )}
                    <div className="lm-prop">
                      <span className="lm-key lm-key-light">Pin Cliente</span>
                      <span className="lm-val lm-val-light lm-mono">
                        {checkPass || "—"}
                      </span>
                    </div>
                    {type !== "PDA" && (
                      <div className="lm-prop">
                        <span className="lm-key lm-key-light">Pin Universal</span>
                        <span className="lm-val lm-val-light lm-mono">
                          {checkAdmin || "—"}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="lm-card lm-card-dark">
                  <div className="lm-card-header lm-card-header-dark">
                    <i className="fas fa-user"></i> Cliente
                  </div>
                  <div className="lm-card-body">
                    <div className="lm-prop">
                      <span className="lm-key lm-key-light">Nombre</span>
                      <span className="lm-val lm-val-light">
                        {checkName || "—"}
                      </span>
                    </div>
                    <div className="lm-prop">
                      <span className="lm-key lm-key-light">Teléfono</span>
                      <span className="lm-val lm-val-light">
                        {checkPhone || "—"}
                      </span>
                    </div>
                    <div className="lm-prop">
                      <span className="lm-key lm-key-light">Email</span>
                      <span className="lm-val lm-val-light">
                        {checkEmail || "—"}
                      </span>
                    </div>
                  </div>
                </div>
                {/* UIDs de la taquilla. Solo se llenan en maquinas RFID: el del cliente
                    lo graba el alquiler por pulsera y el de la maestra la accion remota
                    SET_MASTER_KEY, asi que en maquinas PIN ambos salen vacios. */}
                <div className="lm-card">
                  <div className="lm-card-header">
                    <i className="fas fa-id-card"></i> RFID
                  </div>
                  <div className={`lm-card-body${!rfidMode ? " lm-locked" : ""}`}>
                    {!rfidMode && (
                      <div className="lm-lock-overlay">
                        <i className="fas fa-lock"></i>
                        <span>Solo disponible en modo PULSERA RFID</span>
                      </div>
                    )}
                    <div className="lm-prop">
                      <span className="lm-key">UID Cliente</span>
                      <span className="lm-val lm-mono">
                        {checkRfidUid || "—"}
                      </span>
                    </div>
                    <div className="lm-prop">
                      <span className="lm-key">UID Maestra</span>
                      <span className="lm-val lm-mono">
                        {checkMasterUid || "—"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Column 2: Reservas + Acciones Baqueira */}
              {showBaqueira && (
                <div className="lm-col">
                  <div className="lm-card">
                    <div className="lm-card-header">
                      <i className="fas fa-mountain"></i> Reservas Baqueira
                    </div>
                    <div className="lm-card-body">
                      <div className="lm-tile-grid">
                        <button
                          className="lm-tile-btn lm-tile-primary"
                          onClick={() =>
                            blockType === null && this.changeView("baqueira1")
                          }
                          disabled={blockType !== null}
                        >
                          <i className="fas fa-key"></i>
                          <span>RESERVA DIAS</span>
                        </button>
                        <button
                          className="lm-tile-btn lm-tile-success"
                          onClick={() =>
                            blockType === null && this.changeView("baqueira2")
                          }
                          disabled={blockType !== null}
                        >
                          <i className="fas fa-user-clock"></i>
                          <span>CLICK &amp; COLLECT</span>
                        </button>
                        <button
                          className="lm-tile-btn lm-tile-secondary"
                          onClick={() =>
                            blockType !== null && this.changeView("baqueira3")
                          }
                          disabled={blockType === null}
                        >
                          <i className="fas fa-stop-circle"></i>
                          <span>RESERVA LISTA BLANCA</span>
                        </button>
                        <button
                          className="lm-tile-btn lm-tile-info"
                          onClick={() =>
                            blockType === null && this.changeView("baqueira4")
                          }
                          disabled={blockType !== null}
                        >
                          <i className="fas fa-calendar-alt"></i>
                          <span>RESERVA TEMPORADA</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="lm-card">
                    <div className="lm-card-header">
                      <i className="fas fa-mountain"></i> Acciones Baqueira
                    </div>
                    <div className="lm-card-body">
                      <div className="lm-tile-grid">
                        <button
                          className="lm-tile-btn lm-tile-warning"
                          onClick={() => this.changeView("baqueira5")}
                        >
                          <i className="fas fa-ban"></i>
                          <span>BLOQUEO LISTAS BLANCAS</span>
                        </button>
                        <button
                          className="lm-tile-btn lm-tile-dark"
                          onClick={() => this.changeView("baqueira6")}
                        >
                          <i className="fas fa-network-wired"></i>
                          <span>OTROS</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Column 3: Acciones Remotas + Averias */}
              <div className="lm-col">
                <div className="lm-card">
                  <div className="lm-card-header">
                    <i className="fas fa-hand-paper"></i> Acciones Remotas
                  </div>
                  <div className="lm-card-body">
                    <RemoteActionCustomerSingleAddForm
                      machine={this.props.machine}
                      lockerMatricula={this.state.matrixMatricula}
                      lockerStatus={checkStatus}
                      closeMatrixDialog={this.closeMatrixDialog}
                      onBeforeUnload={this.handleBeforeUnload}
                    />
                  </div>
                </div>
                {(role === "ADMIN" || role === "CUSTOMER") && (
                  <div className="lm-card">
                    <div className="lm-card-header">
                      <i className="fas fa-hand-paper"></i> Averias
                    </div>
                    <div className="lm-card-body">
                      {role === "CUSTOMER" && type === "LICENCIA_BASICA" ? (
                        <button
                          className="lm-action-btn lm-action-secondary"
                          onClick={() => this.setState({ proModalOpen: true })}
                        >
                          <i className="fas fa-lock"></i>
                          {checkStatus !== "FL"
                            ? "MARCAR AVERÍA"
                            : "REPARAR AVERÍA"}
                          <span className="lm-pro-badge">PRO</span>
                        </button>
                      ) : (
                        <button
                          className={`lm-action-btn ${checkStatus !== "FL" ? "lm-action-danger" : "lm-action-success"}`}
                          onClick={() =>
                            this.changeView(
                              checkStatus !== "FL"
                                ? "faultView"
                                : "repairFaultView",
                            )
                          }
                        >
                          <i className="fas fa-times"></i>
                          {checkStatus !== "FL"
                            ? "MARCAR AVERÍA"
                            : "REPARAR AVERÍA"}
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>

            </div>
          </div>
        </CSSTransition>
      );
    }

    // View for "Acciones Baqueira 1" RESERVA POR DIAS
    if (currentView === "baqueira1") {
      return this.renderSubView(
        "baqueira1",
        "Reserva de taquilla por días",
        "calendar-day",
        <RemoteActionBaqueiraRentDaysForm
          lockerType={this.state.lockerType}
          lockerSN={this.state.matrixSN}
          machine={this.props.machine}
          lockerMatricula={this.state.matrixMatricula}
          lockerStatus={checkStatus}
          closeMatrixDialog={this.closeMatrixDialog}
        />,
      );
    }

    // View for "Acciones Baqueira 2" CLICK AND COLLECT
    if (currentView === "baqueira2") {
      return this.renderSubView(
        "baqueira2",
        "Reserva Click & Collect",
        "user-clock",
        <RemoteActionBaqueiraClickAndCollectForm
          lockerType={this.state.lockerType}
          lockerSN={this.state.matrixSN}
          machine={this.props.machine}
          lockerMatricula={this.state.matrixMatricula}
          lockerStatus={checkStatus}
          closeMatrixDialog={this.closeMatrixDialog}
        />,
      );
    }

    // View for "Acciones Baqueira 3" RESERVA POR TEMPORADA
    if (currentView === "baqueira3") {
      return this.renderSubView(
        "baqueira3",
        "Reserva de Lista Blanca",
        "stop-circle",
        <RemoteActionBaqueiraWhitelistForm
          lockerType={this.state.lockerType}
          lockerSN={this.state.matrixSN}
          machine={this.props.machine}
          lockerMatricula={this.state.matrixMatricula}
          lockerStatus={checkStatus}
          closeMatrixDialog={this.closeMatrixDialog}
          whitelistName={whitelistID}
        />,
      );
    }

    // View for "Acciones Baqueira 4" RESERVA TEMPORADA
    if (currentView === "baqueira4") {
      return this.renderSubView(
        "baqueira4",
        "Reserva de temporada",
        "calendar-alt",
        <RemoteActionBaqueiraSeasonForm
          lockerType={this.state.lockerType}
          lockerSN={this.state.matrixSN}
          machine={this.props.machine}
          lockerMatricula={this.state.matrixMatricula}
          lockerStatus={checkStatus}
          closeMatrixDialog={this.closeMatrixDialog}
        />,
      );
    }

    // View for "Acciones Baqueira 5" BLOQUEO LISTA BLANCA
    if (currentView === "baqueira5") {
      return this.renderSubView(
        "baqueira5",
        "Bloqueo de listas blancas",
        "ban",
        <RemoteActionBaqueiraBlockLockerForm
          blockType={this.state.blockType}
          lockerType={this.state.lockerType}
          lockerSN={this.state.matrixSN}
          machine={this.props.machine}
          lockerMatricula={this.state.matrixMatricula}
          lockerStatus={checkStatus}
          closeMatrixDialog={this.closeMatrixDialog}
          refreshMatrixData={refreshMatrix}
          updateBlockType={this.updateBlockType}
        />,
      );
    }

    // View for "Acciones Baqueira 6" OTROS
    if (currentView === "baqueira6") {
      return this.renderSubView(
        "baqueira6",
        "Acciones Baqueira 6",
        "network-wired",
        null,
      );
    }

    if (currentView === "faultView") {
      return this.renderSubView(
        "faultView",
        "Marcar avería en taquilla",
        "exclamation-triangle",
        <RemoteActionFaultAddForm
          lockerType={this.state.lockerType}
          lockerSN={this.state.matrixSN}
          machine={this.props.machine}
          lockerMatricula={this.state.matrixMatricula}
          closeMatrixDialog={this.closeMatrixDialog}
          refreshMatrixData={refreshMatrix}
        />,
      );
    }

    if (currentView === "repairFaultView") {
      return this.renderSubView(
        "repairFaultView",
        "Marcar reparación de avería en taquilla",
        "tools",
        <RemoteActionFaultRepairForm
          lockerType={this.state.lockerType}
          lockerSN={this.state.matrixSN}
          machine={this.props.machine}
          lockerMatricula={this.state.matrixMatricula}
          closeMatrixDialog={this.closeMatrixDialog}
          refreshMatrixData={refreshMatrix}
        />,
      );
    }
  }

  getBackgroundColor(BlockType) {
    const { articles } = this.props;

    // Ensure articles and articles.Whitelist exist before searching
    if (!articles || !articles.Whitelist) {
      return null;
    }

    // Find the whitelist item by its _id
    const whitelistItem = articles.Whitelist.find(
      (item) => item._id === BlockType,
    );

    // If the item is found, return its color; otherwise, return a default value or null
    return whitelistItem ? whitelistItem.color : null;
  }

  getBackgroundName(BlockType) {
    const { articles } = this.props;

    // Ensure articles and articles.Whitelist exist before searching
    if (!articles || !articles.Whitelist) {
      return null;
    }

    // Find the whitelist item by its _id
    const whitelistItem = articles.Whitelist.find(
      (item) => item._id === BlockType,
    );

    // If the item is found, return its color; otherwise, return a default value or null
    return whitelistItem ? whitelistItem.name : null;
  }

  handleBlockedLocker() {
    /*this.props.blockOnlineSale(this.props.machine._id, false, this.state.matrixSN, this.state.matrixMatricula)
      .then((response) => {
        if (this.props.refreshMatrix) {
          this.props.refreshMatrix();
        }
      })
      .catch((error) => {
        console.error('Error blocking locker:', error);
      });
      */
  }

  handleRightClick(e, lock) {
    const { role, type } = this.props;

    // GROUP customers are view-only — no context-menu action.
    if (role === "CUSTOMER" && type === "GROUP") {
      return;
    }

    if (lock.BackOfficeBlock && type !== "PDA") {
      e.preventDefault(); // Prevent default context menu

      const container = document.getElementById("matrixContainer");
      const containerRect = container.getBoundingClientRect();

      this.setState({
        matrixMatricula: lock.Matricula,
        matrixSN: lock.BLEName,
        showButton: true,
        buttonPosition: {
          x: e.clientX - containerRect.left, // Position relative to the container
          y: e.clientY - containerRect.top, // Position relative to the container
        },
      });
    }
  }

  hideButton() {
    this.setState({
      matrixMatricula: "",
      matrixSN: "",
      showButton: false,
    }); // Hide the button
  }

  render() {
    const { currentView, blockType, showButton, buttonPosition } = this.state;
    const { category, matrixs, blockedLockers, type } = this.props;

    const matrixRender = [];
    let lockerStatus = "";
    let matrixIndex = 0;
    let checkKiosc = 0;

    let columnHeight = 0;
    let matrixWidth = 0;

    {
      matrixs.map((matrix) => {
        {
          matrix.Serial === this.props.machine.Serial &&
            matrix.Locker.map((lock, index) => {
              if (matrixIndex < this.props.machine.LastIndex) {
                let lockerSelected = lock.Mode + lock.Wide + lock.Type;

                lock.Configured
                  ? (lockerStatus = lock.Status)
                  : (lockerStatus = "Null");

                //lock.Status == "FB" ? lockerStatus = "AV" : lockerStatus = lock.Status

                switch (lock.Type) {
                  case "S":
                    columnHeight += 45;
                    break;
                  case "M":
                    columnHeight += 90;
                    break;
                  case "L":
                    columnHeight += 135;
                    break;
                  case "XL":
                    columnHeight += 180;
                    break;
                  case "2XL":
                    columnHeight += 225;
                    break;
                  case "3XL":
                    columnHeight += 270;
                    break;
                }

                if (columnHeight >= 270) {
                  columnHeight = 0;

                  if (lock.Wide === "N") {
                    matrixWidth += 45;
                  } else {
                    matrixWidth += 60;
                  }
                }

                const isBlocked = blockedLockers.includes(lock.Matricula);

                matrixRender.push(
                  <div
                    key={index}
                    id={`locker${lockerSelected}`}
                    className={
                      isBlocked || lock.BackOfficeBlock ? "lockerBlocked" : ""
                    }
                    onClick={(e) => {
                      if (lock.BackOfficeBlock) {
                        // If BackOfficeBlock is true, do nothing to block the click
                        return;
                      }
                      // Otherwise, proceed with opening the matrix dialog
                      this.openMatrixDialog(
                        index + 1,
                        lock.BLEName,
                        lockerSelected,
                        lock.BlockType,
                        e,
                      );
                    }}
                    onContextMenu={(e) => this.handleRightClick(e, lock)}
                  >
                    <p>
                      {this.props.getRoomNumber
                        ? this.props.getRoomNumber(index)
                        : index + this.props.machine.FirstIndex}
                    </p>
                    <div id={lockerStatus}>
                      <p>{lockerStatus}</p>
                    </div>
                    {lock.BlockType !== null && lock.Type === "3XL" && (
                      <div
                        style={{
                          backgroundColor: this.getBackgroundColor(
                            lock.BlockType,
                          ),
                          writingMode: "vertical-rl", // Make the text vertical
                          paddingTop: "10px", // Optional padding for better visibility
                          paddingBottom: "10px", // Optional padding for better visibility
                          display: "inline-block", // Ensures the block shrinks to fit the text
                          height: "auto", // Ensures proper height adjustment
                          alignItems: "center", // Optional centering
                          justifyContent: "center", // Optional centering
                          fontSize: "small",
                          borderRadius: "10px",
                          border: "1px solid #ccc",
                        }}
                      >
                        <span>{this.getBackgroundName(lock.BlockType)}</span>
                      </div>
                    )}
                  </div>,
                );

                matrixIndex++;

                if (lock.Position === "C" && checkKiosc === 0) {
                  columnHeight += 135;

                  matrixRender.push(
                    <div key={matrixIndex} id="lockerKioskLeft"></div>,
                  );

                  checkKiosc = 1;
                } else if (lock.Position === "E" && checkKiosc === 0) {
                  columnHeight += 90;

                  matrixRender.push(
                    <div key={matrixIndex} id="lockerEcomKioskLeft"></div>,
                  );

                  checkKiosc = 1;
                } else if (lock.Position === "C" && checkKiosc === 1) {
                  columnHeight += 135;

                  matrixRender.push(
                    <div key={matrixIndex} id="lockerKioskRight"></div>,
                  );

                  checkKiosc = 0;
                } else if (lock.Position === "E" && checkKiosc === 1) {
                  columnHeight += 90;

                  matrixRender.push(
                    <div key={matrixIndex} id="lockerEcomKioskRight"></div>,
                  );

                  checkKiosc = 0;
                }
              }
            });
        }
      });
    }

    return (
      <>
        <div id="matrixContainer" style={{ width: matrixWidth + 40 }}>
          <div className="row" id="lockerMatrix">
            {matrixRender}
          </div>
          <div>
            <Modal
              isOpen={this.state.matrixModalOpen}
              toggle={this.closeMatrixDialog}
              backdrop={true}
              className="locker-modal"
            >
              <ModalHeader
                toggle={this.closeMatrixDialog}
                style={{ padding: 0, border: 'none' }}
              >
                <div style={{
                  padding: '20px 24px 18px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 10,
                  width: '100%',
                  background: '#ffffff',
                }}>
                  {/* Locker number badge — styled like a physical locker door */}
                  <div style={{
                    background: '#1e3a5f',
                    border: '3px solid #334155',
                    borderRadius: 14,
                    padding: '10px 28px',
                    boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.35), 0 6px 18px rgba(15,23,42,0.18)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    minWidth: 90,
                  }}>
                    <span style={{ color: 'rgba(148,163,184,0.7)', fontSize: 10, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase' }}>Taquilla</span>
                    <span style={{ color: '#fff', fontSize: 42, fontWeight: 900, lineHeight: 1, letterSpacing: -1 }}>
                      {this.props.getRoomNumber
                        ? this.props.getRoomNumber(Number(this.state.matrixMatricula) - 1)
                        : Number(this.state.matrixMatricula) + this.props.machine.FirstIndex - 1}
                    </span>
                  </div>
                  {/* Machine name */}
                  <span style={{ color: '#64748b', fontSize: 12, fontWeight: 600, letterSpacing: 0.5 }}>
                    {this.props.machine && this.props.machine.Name}
                  </span>
                  {/* Block warning badge */}
                  {blockType != null && (
                    <div style={{
                      background: this.getBackgroundColor(blockType),
                      borderRadius: 6,
                      padding: '5px 14px',
                      fontSize: 12,
                      fontWeight: 700,
                      color: '#fff',
                      letterSpacing: 0.5,
                    }}>
                      <i className="fas fa-lock mr-2"></i>
                      Bloqueada para: {this.getBackgroundName(blockType)}
                    </div>
                  )}
                </div>
              </ModalHeader>
              <ModalBody>
                <TransitionGroup>{this.infoMatrix()}</TransitionGroup>
              </ModalBody>
            </Modal>
          </div>
          {showButton && (
            <div
              style={{
                position: "absolute",
                top: buttonPosition.y,
                left: buttonPosition.x,
                zIndex: 1000,
              }}
            >
              <Button
                color="primary"
                className={`btn-baqueira`}
                onClick={() => {
                  this.handleBlockedLocker(); // Handle blocked locker logic
                  this.hideButton(); // Hide button after action
                }}
              >
                <i className="fas fa-ban d-block ml-auto mr-auto mb-2"></i>
                Desbloquear taquilla
              </Button>
              <Button
                color="secondary"
                className={`btn-baqueira`}
                onClick={() => {
                  this.hideButton(); // Hide button after action
                }}
              >
                <i className="fas fa-times d-block ml-auto mr-auto mb-2"></i>
                Cancelar
              </Button>
            </div>
          )}
        </div>

        {/* Pro upgrade modal for LICENCIA_BASICA customers */}
        <Modal
          isOpen={this.state.proModalOpen}
          toggle={() => {
            this.setState({ proModalOpen: false });
            this.props.resetProUpgrade();
          }}
          centered
        >
          <ModalHeader
            toggle={() => {
              this.setState({ proModalOpen: false });
              this.props.resetProUpgrade();
            }}
          >
            <i className="fas fa-star mr-2" style={{ color: "#f59e0b" }}></i>
            Función exclusiva de Licencia{" "}
            <span style={{ color: "#f59e0b" }}>PRO</span>
          </ModalHeader>
          <ModalBody>
            {this.props.proUpgradeSent ? (
              <div className="text-center py-3">
                <i
                  className="fas fa-check-circle fa-3x mb-3"
                  style={{ color: "#10b981" }}
                ></i>
                <h5>¡Solicitud enviada!</h5>
                <p className="text-muted">
                  Nuestro equipo se pondrá en contacto contigo para gestionar la
                  actualización a PRO.
                </p>
              </div>
            ) : (
              <>
                <p>
                  La gestión de averías en taquillas desde el panel de cliente
                  es una función exclusiva de la <strong>Licencia PRO</strong>.
                </p>
                <p className="text-muted" style={{ fontSize: 13 }}>
                  Actualiza tu licencia para marcar y reparar averías
                  directamente desde aquí.
                </p>
                {this.props.proUpgradeError && (
                  <p className="text-danger" style={{ fontSize: 12 }}>
                    No se pudo enviar la solicitud. Inténtalo de nuevo más
                    tarde.
                  </p>
                )}
              </>
            )}
          </ModalBody>
          {!this.props.proUpgradeSent && (
            <ModalFooter>
              <Button
                color="secondary"
                onClick={() => {
                  this.setState({ proModalOpen: false });
                  this.props.resetProUpgrade();
                }}
              >
                Cerrar
              </Button>
              <Button
                color="warning"
                onClick={() => this.props.requestProUpgrade()}
                disabled={this.props.proUpgradeLoading}
              >
                {this.props.proUpgradeLoading ? (
                  <span>
                    <i className="fas fa-spinner fa-spin mr-2"></i>Enviando...
                  </span>
                ) : (
                  <span>
                    <i className="fas fa-star mr-2"></i>Solicitar actualización
                    a PRO
                  </span>
                )}
              </Button>
            </ModalFooter>
          )}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
  category: state.auth.category,
  proUpgradeLoading: state.license.loading,
  proUpgradeSent: state.license.sent,
  proUpgradeError: state.license.error,
});

const mapDispatchToProps = (dispatch) => ({
  blockOnlineSale: bindActionCreators(blockOnlineSale, dispatch),
  requestProUpgrade: bindActionCreators(requestProUpgrade, dispatch),
  resetProUpgrade: bindActionCreators(resetProUpgrade, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MatrixConstructor);
